import script from "./DebriefCreateUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./DebriefCreateUpdate.vue?vue&type=script&setup=true&lang=js"

import "./DebriefCreateUpdate.vue?vue&type=style&index=0&id=16cc5abf&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-front-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16cc5abf"]])

export default __exports__